import React, { useEffect, useState } from "react";
import { decodeHtml } from "../../../../../assests/extention/commonfunction";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import { useLocation } from "react-router-dom";
import { FilterCVListings } from "../../../../../redux/cv/action";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";
import { useDispatch, useSelector } from "react-redux";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { navigateToNextTab } from "../../../../Common/FewCommonMethods";
import Access from "../../../../CustomComponents/Access/Access";
import ProfileImageWithFallback from "../../../../../common/ProfileImageWithFallback";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
const size = 15;

export default function CVFilterListings({ setTotalandsize }) {
  const dispatch = useDispatch();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const urexperttoken = localStorage.getItem("urexperttoken");
  const { state, setPageNumber } = useAllFilterBaseContext();
  const { pageNumber } = state;
  const getallcv = useSelector(({ cv: { getfilterdcv } }) => getfilterdcv);
  const expertslist = getallcv?.experts || [];

  const location = useLocation();
  const indcatsub = location?.state?.indcatsub;
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");

  const data = {
    method: "GET",
    type: 6,
    index: pageNumber,
    size: size,
    industry_id: indcatsub?.industry_id,
    category_id: indcatsub?.category_id,
    search: state.search,
    filter: [
      {
        id: "36",
        title: "Search Expert",
        filter_type: "6",
        value: state?.search,
      },
      {
        id: "38",
        title: "SubCategory",
        filter_type: "5",
        values: state?.industries,
      },
      {
        id: "37",
        title: "sort by",
        filter_type: "2",
        values: state?.sortByTime,
      },
      {
        id: "39",
        title: "Skills",
        filter_type: "5",
        values: state?.specialities,
      },
      {
        id: "40",
        title: "Language",
        filter_type: "2",
        values: state?.sortlanguage,
      },
      {
        id: "41",
        title: "Education",
        filter_type: "2",
        values: state?.education,
      },
      {
        id: "42",
        title: "Location",
        filter_type: "2",
        values: state?.location,
      },
      {
        id: "43",
        title: "Experience",
        filter_type: "2",
        values: state?.experience,
      },
    ],
  };

  useEffect(() => {
    dispatch(FilterCVListings(data));
  }, [state]);

  const Downloaded = localStorage.getItem("downloaded");

  useEffect(() => {
    setTotalandsize({
      total: getallcv?.count || 0,
      size: size || 0,
    });
  }, [getallcv]);

  const applyandbitjob = (secitem) => {
    setSelectedItem(secitem);
    setModal(true);
  };

  const openDetails = (id) => {
    localStorage.setItem("prevCVPage", 'searchdownloadcvbycategory');
    navigateToNextTab(`cvdetails/${id}`)
  };



  return (
    <>
      {/* {JSON.stringify(state)} */}
      {Array.isArray(expertslist) && expertslist.length > 0 ? (
        <>
          <div className="download-second">
            {Array.isArray(expertslist) &&
              expertslist?.map((item, index) => (
                <div className="filter-detail" key={index}>
                  <div className="filter-detail-first col-md-7">
                    {
                      item?.downloaded == 1 &&
                      <ProfileImageWithFallback
                        url={item?.profile_image}
                        className="profile-img"
                        alt=""
                      />}
                    <div>
                      {
                        item?.downloaded == 1 ?
                          <>
                            <h5>
                              {decodeHtml(item?.first_name)} {decodeHtml(item?.last_name)}
                            </h5>
                            <h6>{decodeHtml(item?.designation)}</h6>
                          </>
                          : <></>
                      }
                      <CustomReactQuillDescription value={item?.about} displyreadorless={false} />

                      <div className="proposal">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/location.svg`}
                            alt=""
                          />
                          {item?.working_country_title}
                        </p>
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/year-box.svg`}
                            alt=""
                          />
                          {item?.experience} years
                        </p>
                        <p>
                          {" "}
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/dollar-1.svg`}
                          />
                          {item?.price_per_hour}/Hour - {item?.price_per_month}
                          /Month
                        </p>
                      </div>
                      <div className="photoshop">
                        {item?.skills &&
                          Array.isArray(item?.skills) &&
                          item?.skills.map((item1, index1) => (
                            <p key={index1}> {item1.title} </p>
                          ))}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      urexperttoken
                        ? openDetails(item.id)
                        : applyandbitjob(item.id);
                    }}
                    className="buttons border-button"
                    fdprocessedid="pvvz"
                  >
                    View details
                  </button>
                </div>
              ))}
          </div>

          <CommonPagination totalitemcounts={getallcv?.count} size={size}
            pageNumber={state?.pageNumber}
            setPageNumber={setPageNumber}
          />
        </>
      ) : (
        <PostNotFound title={"Experts Not Found..."} />
      )}
      {modal ? (
        <Access
          modal={modal}
          setModal={setModal}
          pathurl={`/${lan}/cvdetails/${selectedItem}`}
          state={"state"}
          checkpermission={"apply_jobs"}
        />
      ) : (
        ""
      )}
    </>
  );
}

// PREEMPTIVE HMR BURST
